import log from "loglevel"

import { AppDispatch, RootState } from "../../redux/store"
import { restoreExistingSession } from "./restoreExistingSession"

let checkInProgress = false

/**
 * Force an immediate session/token freshness check.
 *
 * The periodic token refresh in tokenRefresh.ts only polls every 60s via setTimeout, which
 * can be throttled or suspended while the app is backgrounded (mobile OS, or a backgrounded
 * browser tab). That can leave an expired access token in memory for a while after the app
 * is resumed, causing portal API calls to fail with 401 until the next scheduled poll catches
 * up. Call this from an app-resume / tab-visible event to close that window.
 */
export const checkSessionOnResume =
  () => async (dispatch: AppDispatch, getState: () => RootState, services: any) => {
    if (checkInProgress) {
      return
    }
    checkInProgress = true
    try {
      log.info("checkSessionOnResume: app resumed, checking session")
      await restoreExistingSession(dispatch, getState, services.api)
    } catch (err) {
      log.warn(`checkSessionOnResume: ${err}`)
    } finally {
      checkInProgress = false
    }
  }
